import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ShowErrorComponent } from '../show-error/show-error.component';
import {
  AbstractControl,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';

@Component({
  selector: 'app-input-text',
  imports: [CommonModule, ShowErrorComponent, FormsModule, ReactiveFormsModule],
  templateUrl: './input-text.component.html',
})
export class InputTextComponent {
  @Input() label!: string;
  @Input() placeholder = '';
  @Input() type: 'text' | 'email' | 'password' | 'date' | 'textarea' = 'text';
  @Input() control!: FormControl | AbstractControl | null;
  @Input() showError = true;
  @Input() readonly = false;
  @Input() autocomplete: string = 'on';

  get formControl(): FormControl {
    return this.control as FormControl;
  }

  get normalizedFieldName(): string {
    if (!this.label) return '';
    if (this.label === this.label.toUpperCase()) {
      return this.label;
    }
    return this.label.charAt(0).toLowerCase() + this.label.slice(1);
  }

  get isRequired(): boolean {
    if (!this.control) return false;
    const validator = this.control.validator
      ? this.control.validator({} as any)
      : null;
    return validator ? validator['required'] === true : false;
  }
}
